import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgxSpinnerService } from 'ngx-spinner';

import { CommonService } from '@services/common.service';
import { LoginService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
})
export class ForgotpasswordComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  forgotform!: UntypedFormGroup;

  // Angular 18 signal
  readonly mailsent = signal(false);

  constructor(
    private readonly sharedService: SharedService,
    private readonly fb: UntypedFormBuilder,
    private readonly as: LoginService,
    private readonly spinner: NgxSpinnerService,
    private readonly commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.subscribeToForgotEmail();
  }

  private createForm(): void {
    this.forgotform = this.fb.group({
      userId: [
        null,
        [
          Validators.required,
          Validators.maxLength(50),
          this.commonService.spaceValidator.bind(this.commonService),
        ],
      ],
      timeZone: [''],
    });
  }

  private subscribeToForgotEmail(): void {
    this.as.ForgotEmail
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((payload) => {
        if (payload != null) {
          this.spinner.hide();

          this.mailsent.set(true);

          setTimeout(() => {
            this.mailsent.set(false);
            this.sharedService.forgotcomponent('login');
          }, 1000);
        }
      });
  }

  cancel(component: string): void {
    this.sharedService.forgotcomponent(component);
  }

  submit(): void {
    if (this.forgotform.valid) {
      this.spinner.show();

      const formValue = {
        ...this.forgotform.getRawValue(),
        timeZone: this.commonService.getBrowserTimeZone(),
      };

      this.as.emailforforgotpassword(formValue);
    } else {
      this.commonService.validateAllFormFields(this.forgotform);
    }
  }

  getError(
    control: AbstractControl | null,
    name: string
  ): string | null {
    if (!control?.touched || !control.errors) {
      return null;
    }

    if (control.errors['required']) {
      return `${name} is required.`;
    }

    if (control.errors['minlength']) {
      return 'Please enter minimum 3 characters';
    }

    if (control.errors['pattern']) {
      return `${name} must be valid [a-b and A-B] only`;
    }

    if (control.errors['space']) {
      return 'Only one space allows between the letters';
    }

    return null;
  }

  ngOnDestroy(): void {
    this.as.dispose();
  }
}
